<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg3642"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs3646"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath3656"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path3654" /></clipPath></defs><g
     id="g3648"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g3650"><g
         id="g3652"
         clip-path="url(#clipPath3656)"><g
           id="g3658"
           transform="translate(224,102)"><path
             d="M 0,0 H -209 V 395 H 186 V 192.004"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path3660" /></g><g
           id="g3662"
           transform="translate(156,497)"><path
             d="M 0,0 H 113 V -99.063 L 56.5,-70.349 0,-99.063 Z"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path3664" /></g><g
           id="g3666"
           transform="translate(212.5,157.25)"><path
             d="M 0,0 C 0,78.563 63.688,142.25 142.25,142.25 220.812,142.25 284.5,78.563 284.5,0 284.5,-78.563 220.812,-142.25 142.25,-142.25 63.688,-142.25 0,-78.563 0,0 Z"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path3668" /></g><g
           id="g3670"
           transform="translate(307,106)"><path
             d="M 0,0 H 69.997 C 93.683,0 113,19.317 113,43.003 v 0.995 C 113,67.683 93.683,87 69.997,87 H 18"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path3672" /></g><g
           id="g3674"
           transform="translate(333.5117,227.3682)"><path
             d="M 0,0 -34.403,-34.465 0.064,-68.868"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path3676" /></g></g></g></g></svg>
</template>
